module.exports = __webpack_public_path__ + "img/home3.911f0dbe.png";